import React from 'react';
import './App.css';
// import { debounce } from 'lodash';
import SampleTableComponent from './SampleTable'
import ComparisonTableComponent from './ComparisonTable'
import GutenbergBookTreeComponent from './GutenbergBookTree'
import BookSumBookTreeComponent from './BookSumBookTree'
import NarrativeQABookTreeComponent from './NarrativeQABookTree'
import GoodReadsComponent from './GoodReads'
import LoadDataComponent from './LoadDataComponent'
import { parse_query_string } from './Utils';
import {
  HashRouter as Router,
  Switch,
  Route,
  NavLink
} from "react-router-dom";
// import {
//    parse_query_string // encode_query_params,
// } from './Utils';

type AppProps = {};
type StringSet = {[k: string]: boolean};
type AppState = {};

class App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    this.state = {};
  }

  componentDidUpdate(prevProps: AppProps) {
    // if (this.props.all_data.id !== prevProps.all_data.id) {
    //   console.log('Data changed!');
    //   // this.setState(newState as any)
    // }
  }

  componentDidMount () {
    const query_dict = parse_query_string();
    if (query_dict.page) {
      // https://stackoverflow.com/questions/32307891/creating-a-location-object-in-typescript
      window.location = ('#' + query_dict.page) as any;
    }
  }

  updateState(update: any) {
    this.setState(update);
    console.log('update', update);
  }

  handleStateChange(key: string, event: any) { // KeyboardEvent
    const update: any = {};
    update[key] = event.target.value;
    this.updateState(update);
  }

  showError(err: any) {
    // TODO: better
    console.error(err);
    alert(err);
  }

  render() {
    console.log('rerender');

    return (
        <Router>
          <div>
            <nav className="navbar">
              <ul>
                <li style={{fontWeight: 'bold'}}>
                    Recursively Summarizing Books with Human Feedback
                </li>
                <li>
                  <NavLink exact to="/">Home</NavLink>
                </li>
                  {/*
                <li>
                  <NavLink to="/tldr">TL;DR samples</NavLink>
                </li>
                <li>
                  <NavLink to="/tldr_comparisons">TL;DR human comparisons</NavLink>
                </li>
                <li>
                  <NavLink to="/cnndm">CNN/DM samples</NavLink>
                </li>
                  */ }
                <li>
                  <NavLink to="/gutenberg">Gutenberg</NavLink>
                </li>
                <li>
                  <NavLink to="/booksum">BookSum</NavLink>
                </li>
                <li>
                  <NavLink to="/narrativeqa">NarrativeQA</NavLink>
                </li>
                <li>
                  <NavLink to="/goodreads">GoodReads 2020</NavLink>
                </li>
              </ul>
            </nav>

            {/* A <Switch> looks through its children <Route>s and
                renders the first one that matches the current URL. */}
            <div className="content">
              <Switch>
                <Route exact path="/tldr">
                  <Samples dataset="tldr" n_shards={1}/>
                </Route>
                <Route exact path="/tldr_comparisons">
                  <Comparisons dataset="tldr" n_shards={1}/>
                </Route>
                <Route exact path="/cnndm">
                  <Samples dataset="cnndm" n_shards={115}/>
                </Route>
                <Route exact path="/gutenberg">
                  <GutenbergTrees dataset="gutenberg"/>
                </Route>
                <Route exact path="/booksum">
                  <BookSumTrees dataset="booksum"/>
                </Route>
                <Route exact path="/narrativeqa">
                  <NarrativeQATrees dataset="narrativeqa"/>
                </Route>
                <Route exact path="/goodreads">
                  <GoodReads dataset="goodreads"/>
                </Route>
                <Route exact path="/">
                  <Home />
                </Route>
              </Switch>
            </div>
          </div>
        </Router>
    );
  }
}

function Home() {
  return <div className="home">
    <h1>Home</h1>
    <p>This website hosts samples from the models trained in the <a href="https://arxiv.org/abs/2109.10862">Recursively Summarizing Books with Human Feedback</a> paper. There are 3 categories of samples:</p>
    <ul>
      <li><NavLink to="/gutenberg"><strong>Gutenberg:</strong></NavLink> Summaries of books from Project Gutenberg.  We provide 512 random selections, as well as the 512 most popular books by download frequency.</li>
      <li><NavLink to="/narrativeqa"><strong>NarrativeQA:</strong></NavLink> Summaries of NarrativeQA books and movie scripts, as well as outputs from zero-shot question answering models that take in those summaries.</li>
    </ul>
    <h2>Content warning</h2>
    <p>Many of the books and movie scripts (and accompanying summaries) may contain sensitive content.  Please take caution when reading.</p>
    </div>;
}

function Samples(props: any) {
  let desc;
  if (props.dataset === "cnndm") {
    desc = <span>Samples are non-cherry-picked.  Models use T=0 for sampling.</span>;
  } else {
    desc = <span>
      Posts are filtered for content according to the procedure described <NavLink exact to="/">here</NavLink>.  Models use T=0 for sampling.
     </span>;
  }
  return (
    <div>
      {desc}
      <br/>
      <br/>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="samples" component={SampleTableComponent} n_shards={props.n_shards}
    />
    </div>
  )
}

function Comparisons(props: any) {
  return (
    <div>
      Posts are filtered for content according to the procedure described <NavLink exact to="/">here</NavLink>.  Models use T=0 for sampling.
      <br/>
      <br/>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="comparisons" component={ComparisonTableComponent} n_shards={props.n_shards}/>
    </div>
  )
}

function BookSumTrees(props: any) {
  return (
    <div>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="tree" component={BookSumBookTreeComponent} n_shards={1024} initial_data_id={"175b/0"}/>
    </div>
  )
}
function GutenbergTrees(props: any) {
  return (
    <div>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="tree" component={GutenbergBookTreeComponent} n_shards={1024} initial_data_id={"175b/0"}/>
    </div>
  )
}

function NarrativeQATrees(props: any) {
  return (
    <div>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="tree" component={NarrativeQABookTreeComponent} n_shards={1024} initial_data_id={"175b/0"}/>
    </div>
  )
}

function GoodReads(props: any) {
  return (
    <div>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="tree" component={GoodReadsComponent} n_shards={1} initial_data_id={""}/>
    </div>
  )
}


export default App;
